/* eslint-disable ember/classic-decorator-hooks */
import EmberObject from '@ember/object';
import FilterConstants from '../../../../filter-constants';
import * as CommonUtils from '../../../../utils/common';

export default class MultipleFeedbackHighPassIdealOpAmp extends EmberObject {
  // Inputs
  r2 = null;
  c1 = null;
  c5 = null;
  optimization = null;
  stageFp = null;
  gain = null;
  stageQ = null;
  algorithm = null;

  // Outputs
  iBias = null;
  gbw = null;
  rOut = null;
  specialGain = null;
  name = 'ideal';
  slewRate = 0;
  rOutOverGBW = FilterConstants.Limits.INFINITY;

  init() {
    super.init();

    if (
      CommonUtils.isNullOrUndefined(this.r2) ||
      CommonUtils.isNullOrUndefined(this.c1) ||
      CommonUtils.isNullOrUndefined(this.c5) ||
      CommonUtils.isNullOrUndefined(this.stageFp) ||
      CommonUtils.isNullOrUndefined(this.gain) ||
      CommonUtils.isNullOrUndefined(this.stageQ) ||
      CommonUtils.isNullOrUndefined(this.optimization) ||
      CommonUtils.isNullOrUndefined(this.algorithm)
    ) {
      throw 'Required values are incomplete. Please provide r2, c1, c5, stageFp, stageQ, gain, optimization, and algorithm';
    }

    this.iBias = this.computeIBias();
    this.gbw = this.computeGbw();
    this.rOut = this.computeROut(this.gbw);
    this.specialGain = this.computeSpecialGain();
  }

  computeSpecialGain() {
    return 1 + this.c1 / this.c5;
  }

  computeGbw() {
    var fMultiplier = this.optimization.opAmpRequirementSpecValues.fMultiplier;
    var result = fMultiplier * this.stageFp * this.gain * Math.max(this.stageQ, 1);
    return result;
  }

  computeIBias() {
    var dcOutputVoltageFromIBias = this.optimization.opAmpRequirementSpecValues.dcOutputVoltageFromIBias;
    var iBiasResistance = this.r2;
    return dcOutputVoltageFromIBias / iBiasResistance / this.gain;
  }

  computeROut(gbw) {
    return this.rOutOverGBW * gbw;
  }
}
